module.exports = __webpack_public_path__ + "img/banner-notice.853ab2ea.png";